import styled from 'styled-components';
import { Footer } from '@ibinder/ui-common-core';

export const StyledFooter = styled(Footer)`
  padding: 0 1rem;
  color: ${({ theme }) => theme.colors.discrete};
  font-size: ${({ theme }) => theme.fontStyles.extraSmallFont.fontSize}px;
  font-weight: ${({ theme }) => theme.fontStyles.extraSmallFont.fontWeight};
  > div {
    flex-direction: row;
    > div {
      svg {
        width: 5rem;
      }
    }
  }
`;
